import { CardMediaSlot } from "@/components/landing/CardMediaSlot";

export function Milestones({ content, media = [] }) {
  return (
    <section id="milestones" className="section milestones-section" data-slide="02" data-testid="milestones-section">
      <div className="section-heading wide">
        <p className="overline" data-testid="milestones-overline">{content.overline}</p>
        <h2 data-testid="milestones-title">{content.title}</h2>
        <p data-testid="milestones-description">{content.description}</p>
      </div>

      <div className="milestone-track" data-testid="milestone-track">
        {content.items.map((item, index) => (
          <article className="milestone-item" key={`${item.year}-${item.title}`} data-testid={`milestone-item-${index + 1}`}>
            <CardMediaSlot image={media[index]?.image} label={item.title} testId={`milestone-media-${index + 1}`} className="compact-media" />
            <span data-testid={`milestone-year-${index + 1}`}>{item.year}</span>
            <h3 data-testid={`milestone-title-${index + 1}`}>{item.title}</h3>
            <p data-testid={`milestone-text-${index + 1}`}>{item.text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}